import React, { useCallback } from 'react';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import { StyledNuvoBox } from '#/common/styles/template';
import FileUpload from '#/common/components/FileUpload/FileUpload';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';

export interface FileUploadStepProps {
  uploadedFile: File | null;
  handleFileSelect: (file: File) => void;
  handleFileDelete: () => void;
}

const FileUploadStep: React.FC<FileUploadStepProps> = ({
  uploadedFile,
  handleFileSelect,
  handleFileDelete,
}) => {
  const { isDesktop } = useViewport();
  const onFileSelect = useCallback(
    (files: File[]) => {
      if (files.length > 0) {
        handleFileSelect(files[0]);
      }
    },
    [handleFileSelect],
  );
  return (
    <StyledNuvoBox isDesktop={isDesktop}>
      <div className="box-caption">
        <NuvoLabel>Import File</NuvoLabel>
      </div>
      <FileUpload
        files={
          uploadedFile
            ? [
                {
                  name: uploadedFile.name,
                  size: uploadedFile.size,
                  mimeType: uploadedFile.type,
                },
              ]
            : []
        }
        onFileSelect={onFileSelect}
        onFileDelete={handleFileDelete}
        disableUpload={!!uploadedFile}
        acceptedFormats={['.csv']}
        deleteTxt="Clear Selection"
      />
    </StyledNuvoBox>
  );
};

export default React.memo(FileUploadStep);
